import React, { useEffect, useState, useContext } from 'react';
import acm from './ClientForm.module.css';
import Mobile from "../../../../assets/Icon/Mobile";
import At from "../../../../assets/Icon/At";
import Time from "../../../../assets/Icon/Time";
import Id from "../../../../assets/Icon/Id";
import Client from "../../../../assets/Icon/User";
import { useClient } from '../../../../hooks/useClient';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import { AppContext } from "../../../../providers/appProvider";
import { selectStyle } from './selectStyle';
import SellerSelect from '../SellerSelect/SellerSelect';
const AddClientForm = ({ newBooking, setNewBooking, validates }) => { 
    const { appState, app } = useContext(AppContext);
    const [selectedSeller, setSelectedSeller] = useState(null);

    const handleSellerChange = (selectedOption) => {
        setSelectedSeller(selectedOption ? selectedOption.value : null);
    };
    const { clientService } = useClient(100);
    const [searchClients, setSearchClient] = useState([]);
    const [isCompany, setIsCompany] = useState(false); // State to manage checkbox

    const [client, setClient] = useState({
        id: 0,
        firstname: "",
        lastname: "",
        personal: "",
        email: "",
        password: "",
        mobile: "",
        companyName: "",
        companyIdentifier: ""
    });

    useEffect(() => {
        if (newBooking.client) {
            setNewBooking(prevState => ({
                ...prevState,
                client_id: newBooking.client.id
            }));
        } 
    }, []);

    const handleClientChange = async (event) => {
        let val = event.target.value;
        setClient(prevClient => ({
            ...prevClient,
            [event.target.name]: val
        }));

        var searchedLength = 0;

        if (val.length > 0) {
            const tempClient = { ...client, [event.target.name]: val };
            console.log(tempClient)
            setNewBooking(prevState => ({
                ...prevState,
                client_id: 0,
                client: tempClient
            }));

            var resultClients = await clientService.search(tempClient, 5);

            if (resultClients && resultClients.clients && resultClients.clients.length > 0) {
                setSearchClient(resultClients.clients);
                searchedLength = 1;
            } else {
                setSearchClient([]);
                searchedLength = 0;
            }

            setNewBooking(prevState => ({
                ...prevState,
                searchedClients: searchedLength,
            }));
        } else {
            if (searchClients.length > 0) {
                setNewBooking(prevState => ({
                    ...prevState,
                    searchedClients: 1,
                }));
            }
        }
    };

    const handlePhoneChange = (phone) => {
        let val = phone;
        setClient(prevClient => ({
            ...prevClient,
            ["mobile"]: val
        }));

        if (val.length > 0) {
            const tempClient = { ...client, ["mobile"]: val };
            setNewBooking(prevState => ({
                ...prevState,
                client_id: 0,
                client: tempClient
            }));
        }
    };

    const handleClientClick = (idx) => {
        setClient(searchClients[idx]);
        setNewBooking(prevState => ({
            ...prevState,
            client_id: searchClients[idx].id,
            searchedClients: 0,
            client: {}
        }));
        setSearchClient([]);
    };

    const handleCheckboxChange = (event) => {
        setClient({
            id: 0,
            firstname: "",
            lastname: "",
            personal: "",
            email: "",
            password: "",
            mobile: "",
            companyName: "",
            companyIdentifier: ""
        });
        setIsCompany(event.target.checked);
    };
    const setModel = async (salerId, dealerId) => { 
        setNewBooking({
            ...newBooking,
            user_id:  salerId == undefined ? 0 : salerId.value,
        })
    } 
    return (
        <div>

                <fieldset className={acm.formField}>
                    <legend>კლიენტი</legend>
                    
                    {app.hasPermission("Booking_SALER_ADD") && 
                        <>
                            <SellerSelect
                            options={appState.salers}
                            styles={selectStyle}
                            value={selectedSeller}
                            placeholder="კლიენტი"
                            onChange={setModel}
                            validate={validates && validates.saler_id ? true : false}
                            validateMsg="Not valid"
                            topTitle={true}
                            ></SellerSelect>
                        </>
                    }
                    
                    <div className={acm.inp2col} style={{ marginBottom: 0, marginTop: 10 }}>  
                        <div  className={validates && validates.mobile ? acm.groupInput + ' errorInput'  : acm.groupInput}>
                            <PhoneInput
                                defaultCountry="ge"
                                value={client.mobile} 
                                hideDropdown={false}
                                name="mobile"  
                                onChange={(phone) => handlePhoneChange(phone)}
                            />
                            {validates && validates.mobile &&
                            <div className={ acm.errorMsg } >{validates.mobile.message}</div>}
                        </div>
                    </div>
   
                    <div className={acm.inpcol}>
                        {!isCompany && (
                            <>
                                <div className={acm.groupInput}>
                                    <div className={acm.groupInputIcon}>
                                        <input type="textS" 
                                            className={validates && validates.personal ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                            placeholder="პირადი ნომერი" name="personal" value={client.personal} onChange={handleClientChange} autoComplete="off"
                                            onInput={(e) => {
                                                e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                            }}
                                        />
                                        <div className={acm.crmIcon}>
                                            <Id />
                                        </div>
                                    </div>
                                    {validates && validates.personal &&
                                        <div className={ acm.errorMsg } >{validates.personal.message}</div>}
                                </div>
                                    <div className={acm.inp2col}>
                                    <div className={acm.groupInput}>
                                        <div className={acm.groupInputIcon}>
                                            <input type="textS" 
                                                className={validates && validates.firstname ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                                placeholder="სახელი" name="firstname" value={client.firstname} onChange={handleClientChange} autoComplete="off"
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                                }}
                                            />
                                            <div className={acm.crmIcon}>
                                                <Client />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={acm.groupInput}>
                                        <div className={acm.groupInputIcon}>
                                            <input type="textS"
                                                className={validates && validates.lastname ? acm.input + ' ' +  acm.errorInput : acm.input } 
                                                placeholder="გვარი" name="lastname" value={client.lastname} onChange={handleClientChange} autoComplete="off" 
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9\s]/g, '').toUpperCase();
                                                }}
                                            />
                                            <div className={acm.crmIcon}>
                                                <Client />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
 
                    {isCompany && (
                        <div className={acm.inp2col}>
                            <div className={acm.groupInput}>
                                <div className={acm.groupInputIcon}>
                                    <input type="textS" 
                                        className={validates && validates.companyName ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                        placeholder="კომპანიის დასახელება" name="companyName" value={client.companyName} onChange={handleClientChange} autoComplete="off"
                                    />
                                    <div className={acm.crmIcon}>
                                        <Client />
                                    </div>
                                </div>
                            </div>

                            <div className={acm.groupInput}>
                                <div className={acm.groupInputIcon}>
                                    <input type="textS"
                                        className={validates && validates.companyIdentifier ? acm.input + ' ' +  acm.errorInput : acm.input } 
                                        placeholder="საინდენტიფიკაციო #" name="companyIdentifier" value={client.companyIdentifier} onChange={handleClientChange} autoComplete="off" 
                                    />
                                    <div className={acm.crmIcon}>
                                        <Client />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className={acm.groupInput}>
                        <div className={acm.groupInputIcon}>
                            <input type="textS" 
                                className={validates && validates.email ? acm.input + ' ' +  acm.errorInput : acm.input  } 
                                placeholder="ელ-ფოსტა" name="email" value={client.email} 
                                onChange={handleClientChange} 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^A-Za-z0-9.@\-_]/g, '').toUpperCase();
                                }}   
                                autoComplete="off" />
                            <div className={acm.crmIcon}>
                                <At />
                            </div>
                        </div>
                    </div>


                    <div className={acm.groupInput}>
                        <label>
                            <input type="checkbox" checked={isCompany} onChange={handleCheckboxChange} />
                            კომპანია
                        </label>
                    </div>

                    {searchClients && searchClients.length > 0 && (
                        <div style={{ width: '100%', position: 'relative' }} >
                            <div className={validates && validates.searchedClients ? acm.searchClient + ' ' +  acm.errorInput : acm.searchClient }  >
                                {validates && validates.searchedClients &&
                                    <span style={{ color: 'rgb(225, 29, 72)' , background: '#fff', fontSize: '10px', position: 'absolute', top: '-6px', right: '7px', lineHeight: '1'}} >{validates.searchedClients.message}</span>
                                }
                                {searchClients.map((client, index) => (
                                    <div key={index} onClick={() => handleClientClick(index)}>
                                         <>
                                            {isCompany
                                            ? `${client.companyName} (${client.companyIdentifier})`
                                            : `${client.firstname} ${client.lastname} (${client.personal})`}
                                        </>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </fieldset>
        </div>
    );
};

export default AddClientForm;